
import api from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  bindCoupon ({ commit }, payload) {
    return api('/api/coupon', 'POST', payload)
  },
  getCoupons ({ commit }, payload) {
    return api('/api/coupons', 'GET', payload)
  },
}

const mutations = {
}

export default {
  state,
  mutations,
  getters,
  actions
}
